export default __webpack_public_path__ + "static/sunsoaked-banner-desktop-b1e2868353d302134c4f3eb0341d7085.webp";